import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import stripeLogo from "../assets/stripepayment.png";
import { TailSpin } from "react-loader-spinner";
const PayButton = ({ cartitem }) => {
  const { user, total } = useStateContext();
  const navigate = useNavigate();

  const [loaderSpinner, SetLoaderSpinner] = useState(false);

    const handleCheckout = () => {
      SetLoaderSpinner(true);
      user
        ? axios
            .post("https://matrix-api-h2bb.onrender.com/create-checkout-session", {
              cartitem,
              customer_email: user.email,
              total_price: total,
              order_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
            })
            .then((res) => {
              if (res.data.url) {
                window.location.href = res.data.url;
              }
              SetLoaderSpinner(false);
            })
            .catch((err) => console.log(err.message))
        : navigate("/login");
    };
    
  return (
    <>
      <button onClick={() => handleCheckout()}>
        {" "}

        {loaderSpinner ? (
                <TailSpin
                  height="30"
                  width="30"
                  color="#f0a6f0"
                  ariaLabel="tail-spin-loading"
                  radius="1"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              ) : (
                   <div className="wrapper" ><img src={stripeLogo} alt="" srcset="" /> <p>Check Out</p></div> 
              )}

      </button>
    </>
  );
};

export default PayButton
